import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { Button } from 'antd'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import DateCell from '../../../../elements/Table/Cells/DateCell'

const CheckboxTable = checkboxHOC(CustomTable)

function List (props) {
  const {
    list,
    fetch,
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
    fetching,
    tableRef,
    onShow,
  } = props
  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }
  const columns = [
    {
      Header: 'System ID',
      accessor: '_key',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Serial', accessor: 'serial' },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Department', accessor: 'department.name' },
    { Header: 'Reference', accessor: 'reference.no' },
    { Header: 'Category', accessor: 'category' },
    { Header: 'Type', accessor: 'type' },
    { Header: 'Description', accessor: 'description' },
    { Header: 'Start Date', accessor: 'date.start', Cell: DateCell },
    { Header: 'End Date', accessor: 'date.end', Cell: DateCell },
    { Header: 'Amount', accessor: 'amount', Cell: MoneyCell },
  ]

  return (
    <CheckboxTable
      {...checkboxProps}
      withRef={tableRef}
      data={list}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          New{' '}
        </Button>
      )}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
